






















import Vue from 'vue'
import Component from 'vue-class-component'
import SidebarNav from './components/sidebar/SidebarNav.vue'

@Component({
  components: {
    SidebarNav
  }
})
export default class App extends Vue {
  private componentClass = "Application"

  get isAuthentificated(): boolean {
    return this.$store.getters.isAuthentificationAuthenticated
  }
}
